import { AfterViewInit, Component, Input, WritableSignal } from '@angular/core';
import { environment } from '../../../../environments/environment';
import { TurnstileRenderOptions } from '@interfaces/turnstile/turnstile-options-interface';

declare global {
  interface Window {
    turnstile: {
      render: (id: string | HTMLElement, options: TurnstileRenderOptions) => string;
      getResponse: (id: string | HTMLElement) => string | undefined;
      remove: (id: string | HTMLElement) => void;
    };
    onTurnstileLoad: () => void;
  }
}

@Component({
  selector: 'ln-captcha',
  imports: [],
  templateUrl: './captcha.component.html',
  styleUrl: './captcha.component.css',
})
export class CaptchaComponent implements AfterViewInit {
  private TAG = 'CaptchaComponent';
  @Input({ required: true }) captchaToken!: WritableSignal<string | undefined>;
  private readonly turnstileUrl: string = environment.CLOUDFLARE_TURNSTILE_SCRIPT_URL;
  private publicKey: string = environment.recaptcha.publicKey;

  async ngAfterViewInit(): Promise<void> {
    await this.ensureTurnstileLoaded();
    this.renderTurnstile();
  }

  private ensureTurnstileLoaded(): Promise<void> {
    return new Promise(resolve => {
      if (window.turnstile) return resolve();

      window.onTurnstileLoad = () => {
        resolve();
      };

      // Solo cargar si no está ya en el documento
      if (!document.querySelector('script[src*="turnstile"]')) {
        const script = document.createElement('script');
        script.src = this.turnstileUrl + '?onload=onTurnstileLoad';
        script.async = true;
        script.defer = true;
        document.head.appendChild(script);
      }
    });
  }

  private renderTurnstile() {
    const turnstileOptions: TurnstileRenderOptions = {
      sitekey: this.publicKey,
      theme: 'light',
      callback: token => {
        this.captchaToken.set(token);
        // console.log(`${this.TAG} este es el token del capcha ${token}`);
      },
      'expired-callback': () => {
        this.captchaToken.set(undefined);
      },
      'error-callback': () => {
        this.captchaToken.set(undefined);
      },
    };

    const widgetId = window.turnstile.render('#turnstile-container', turnstileOptions);

    console.log(`${this.TAG} Turnstile widget renderizado con ID:`, widgetId);
  }
}
